export default __webpack_public_path__ + "static/media/chart.7a2b6770.svg";